// extracted by mini-css-extract-plugin
export default {"selecterptd":"defaultmapping_selecterptd__dlkQk","selectecommercetd":"defaultmapping_selectecommercetd__clXuV","mappingtableContainer":"defaultmapping_mappingtableContainer__rC4pn"};